// @flow
import i18n from 'live/services/i18n'
import Auth from 'live/services/authorization'

try {
    document.addEventListener('DOMContentLoaded', function () {
        require('./init')
    })
    const ExtensionService = require('live/services/extension')
    const ServiceLocator = require('live/services/service-locator').default
    const FormWellImport = require('./formWellImport')
    const ImportControl = require('./WellImport/ImportControl').ImportControl

    const wellImport = {
        name: 'POÇO WEB',
        type: 'liverig-pocoweb-wellimport',
        origin: 'Plugin PocoWeb',
        roles: ['input'],
        icon: '/content/plugin-pocoweb/pocowebicon.png',
        ui: {
            form: FormWellImport,
            view: null
        }
    }

    ExtensionService.register(wellImport)

    if (Auth.Permission.isAdmin || Auth.Permission.IMPORT_POCOWEB_DATA) {
        ServiceLocator.getService('import-export-service').then(service => {
            service.register({
                label: 'Poço Web' + ' (' + i18n('external') + ')',
                origin: 'plugin-pocoweb',
                type: 'import',
                assets: ['well', 'intervention', 'rig'],
                body: ImportControl,
                order: 2
            })
        })
    }

} catch (e) {
    console.error(e)
}
